/**
 * "No tutorials available" empty state, shared by the desktop AccountMenu's
 * Preferences submenu and the mobile drawer's Tutoriales accordion
 * (TV1-2294 ticket 28, GAP 3).
 *
 * The drawer used to render NOTHING when `useTourEntries()` came back empty —
 * the whole block sat behind `tourEntries.length > 0` — while desktop rendered a
 * proper empty state. That is a direct violation of `.claude/rules/design-system.md`
 * § Empty States ("Every view, list, tab, dropdown, and content area MUST have
 * one"), and it is the same shape of defect the ticket-18 audit found everywhere
 * two surfaces keep hand-written copies of one thing. It lives here once now, in
 * the same folder as `useTourEntries`, so both consumers show identical copy.
 *
 * Pattern 2 from the design system: icon in a 40px circle + title + description.
 * Strings stay in the `account` namespace, where they already were.
 */

import { Text } from '@mantine/core';
import { IconProgressHelp } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import classes from './TourEntriesEmptyState.module.css';

export function TourEntriesEmptyState() {
  const { t } = useTranslation( 'account' );

  return (
    <div className={classes.emptyState}>
      <div className={classes.emptyStateIcon}>
        <IconProgressHelp size={20} />
      </div>
      <Text className={classes.emptyStateTitle}>
        {t( 'preferences_tutorials_empty_title', 'No hay tutoriales disponibles' )}
      </Text>
      <Text className={classes.emptyStateDescription}>
        {t( 'preferences_tutorials_empty_description', 'Aparecerán aquí a medida que se habiliten secciones' )}
      </Text>
    </div>
  );
}

export default TourEntriesEmptyState;
